import { useState } from 'react';

type Feedback = { type: 'success' | 'error'; msg: string } | null;

export default function Newsletter() {
  const [feedback, setFeedback] = useState<Feedback>(null);

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const decoy = (fd.get('phone_alt') as string) || '';
    const email = (fd.get('email') as string) || '';

    if (decoy.trim()) {
      setFeedback({ type: 'success', msg: '订阅成功，首发瓜料即将送达！' });
      form.reset();
      return;
    }
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      setFeedback({ type: 'error', msg: '请输入有效的邮箱地址。' });
      return;
    }
    fd.delete('phone_alt');

    fetch('https://readdy.ai/api/form/daf8nkptto0ceqqnh83g', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
    })
      .then(async (res) => {
        const text = await res.text();
        let parsed: any = null;
        try { parsed = JSON.parse(text); } catch { parsed = null; }
        const code = parsed?.code;
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text;
        if (res.ok && code === 'OK') {
          setFeedback({ type: 'success', msg: '订阅成功，首发瓜料即将送达！' });
          form.reset();
        } else {
          const isSpam = typeof serverMsg === 'string' && serverMsg.includes('spam');
          setFeedback({
            type: 'error',
            msg: isSpam ? '提交过于频繁，请稍后再试。' : serverMsg || '订阅失败，请稍后重试。',
          });
        }
      })
      .catch(() => setFeedback({ type: 'error', msg: '网络异常，请稍后重试。' }));
  };

  return (
    <section id="contact" className="scroll-mt-20 bg-background-100/70 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-7xl">
        <div className="grid overflow-hidden rounded-3xl bg-foreground-950 lg:grid-cols-2">
          <div className="p-7 md:p-10">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100/15 px-3 py-1 text-xs font-semibold text-accent-300 ring-1 ring-accent-300/30">
              <i className="ri-send-plane-line" />
              第一时间订阅
            </span>
            <h2 className="mt-4 font-heading text-2xl font-black text-background-50 md:text-3xl">不错过任何一个首发瓜</h2>
            <p className="mt-3 text-sm leading-relaxed text-background-200 md:text-base">
              留下邮箱，当关注主题出现热度上升或关键进展时，我们会第一时间把最新瓜料推送到你的邮箱，让抢先成为一种习惯。
            </p>
            <ul className="mt-6 space-y-2.5 text-sm text-background-100/85">
              <li className="flex items-center gap-2"><i className="ri-checkbox-circle-line text-accent-400" />分钟级热点进展通知</li>
              <li className="flex items-center gap-2"><i className="ri-checkbox-circle-line text-accent-400" />抢先首发内容独家整理</li>
              <li className="flex items-center gap-2"><i className="ri-checkbox-circle-line text-accent-400" />随时可退订，绝不骚扰</li>
            </ul>
          </div>

          <div className="flex items-center p-7 md:p-10">
            <form
              data-readdy-form="吃瓜最快-第一时间订阅"
              className="w-full space-y-3"
              onSubmit={submit}
            >
              <div>
                <label htmlFor="subscribe-name" className="mb-1.5 block text-xs font-semibold text-background-200">你的称呼（可选）</label>
                <input
                  id="subscribe-name"
                  name="name"
                  type="text"
                  placeholder="怎么称呼你"
                  className="w-full rounded-lg border border-background-700 bg-background-900 px-3.5 py-2.5 text-sm text-background-50 outline-none transition placeholder:text-background-400 focus:border-accent-400 focus:ring-2 focus:ring-accent-400/30"
                />
              </div>
              <div>
                <label htmlFor="subscribe-email" className="mb-1.5 block text-xs font-semibold text-background-200">常用邮箱</label>
                <input
                  id="subscribe-email"
                  name="email"
                  type="email"
                  required
                  placeholder="you@example.com"
                  className="w-full rounded-lg border border-background-700 bg-background-900 px-3.5 py-2.5 text-sm text-background-50 outline-none transition placeholder:text-background-400 focus:border-accent-400 focus:ring-2 focus:ring-accent-400/30"
                />
              </div>
              <div>
                <label htmlFor="subscribe-focus" className="mb-1.5 block text-xs font-semibold text-background-200">最关注的栏目</label>
                <select
                  id="subscribe-focus"
                  name="focus"
                  className="w-full rounded-lg border border-background-700 bg-background-900 px-3.5 py-2.5 text-sm text-background-50 outline-none transition focus:border-accent-400 focus:ring-2 focus:ring-accent-400/30"
                >
                  <option>全部栏目</option>
                  <option>娱乐八卦</option>
                  <option>影视综艺</option>
                  <option>音乐盛典</option>
                  <option>品牌风向</option>
                  <option>科技新潮</option>
                </select>
              </div>

              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="decoy-field"
              />

              <button
                type="submit"
                className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-bold text-foreground-950 transition hover:bg-accent-400"
              >
                <i className="ri-send-plane-fill" />
                立即订阅抢先瓜料
              </button>
              {feedback && (
                <p className={`text-xs ${feedback.type === 'success' ? 'text-accent-300' : 'text-primary-300'}`}>{feedback.msg}</p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}